import { render } from "./DocumentsStep.vue?vue&type=template&id=713a3f4a"
import script from "./DocumentsStep.vue?vue&type=script&lang=js"
export * from "./DocumentsStep.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__